enum DateFilterType {
	LOADING = 'loading',
	UNLOADING = 'unloading',
	BASED_ON_TERMS = 'based_on_terms'
}

export default DateFilterType
